import React, { useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import CircleButton from './circleButton';
import * as style from './modal.module.scss';
import translations from '../../utils/translations';
import useEscapeKey from '../../hooks/useEscapeKey';

const Modal = ({ toggleOpen, exiting, fullScreen, basicFade, children }) => {
  const parentRef = useRef(null);

  const handleEscape = useCallback(() => {
    toggleOpen();
  }, [toggleOpen]);

  useEscapeKey(handleEscape);

  parentRef.current = document.querySelector('.sitewrap');

  if (parentRef.current) {
    return ReactDOM.createPortal(
      <section
        className={`${style.modalWrap} ${
          exiting ? style.exiting : ''
        } ${fullScreen ? style.fullScreen : ''}`}
      >
        <div className={style.modalInner}>
          <div className={style.closeWrap}>
            <CircleButton
              type="close"
              handleClick={toggleOpen}
              text={translations.t('Close')}
            />
          </div>
          <div
            className={`${style.contentWrap} ${
              basicFade ? style.basicFade : ''
            }`}
          >
            {children}
          </div>
        </div>
        <div className={style.bk} onClick={toggleOpen} />
      </section>,
      parentRef.current
    );
  }
  return null;
};

export default Modal;
